import { useResponsive } from '../hooks/useResponsive';
import { useAppState } from '../context/AppStateContext';
import Sidebar from '../components/layout/Sidebar';
import BottomNav from '../components/layout/BottomNav';
import GlobalHeader from '../components/layout/GlobalHeader';
import StoresTab from '../components/tabs/StoresTab';
import NotificationsPanel from '../components/shared/NotificationsPanel';
import GuestPromptDrawer from '../components/shared/GuestPromptDrawer';

export default function StoresPage() {
  const { isDesktop } = useResponsive();
  const { showNotifications, setShowNotifications } = useAppState();

  if (isDesktop) {
    return (
      <div className="flex h-screen h-dvh bg-gray-50">
        <Sidebar />
        <main className="flex-1 flex flex-col overflow-hidden ml-64">
          <GlobalHeader />
          <div className="flex-1 overflow-y-auto scrollbar-hide">
            <StoresTab />
          </div>
        </main>

        {showNotifications && (
          <NotificationsPanel onClose={() => setShowNotifications(false)} />
        )}

        <GuestPromptDrawer />
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen h-dvh bg-gray-50">
      <main className="flex-1 flex flex-col overflow-hidden pb-nav">
        <StoresTab />
      </main>
      <BottomNav />

      {showNotifications && (
        <NotificationsPanel onClose={() => setShowNotifications(false)} />
      )}

      <GuestPromptDrawer />
    </div>
  );
}
